module.exports = __webpack_public_path__ + "static/media/undraw_thoughts_e49y.a0504713.svg";